<template>
  <span v-if="variant === 'success'" class="badge badge--success">
    <slot></slot>
  </span>
  <span v-else-if="variant === 'warning'" class="badge badge--warning">
    <slot></slot>
  </span>
  <span v-else-if="variant === 'error'" class="badge badge--danger">
    <slot></slot>
  </span>
  <span v-else-if="variant === 'info'" class="badge badge--info">
    <slot></slot>
  </span>
  <span v-else class="badge">
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    variant: {
      type: String
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/modules/badge.scss";
</style>
